import customAxios from "../../utils/customAxios";

// Package hubs are the airports/stations used by the 3km package vicinity rule.
// These helpers return plain data (no Redux) because only the package detail
// page uses them. Each one throws an Error with a readable message on failure.

const getErrorMessage = (error, fallbackMessage) =>
  error?.response?.data?.message || fallbackMessage;

const readHubFromResponse = (response) => {
  const hub = response?.data?.data;
  if (!hub || typeof hub.code !== "string") {
    throw new Error("The server returned an unexpected response.");
  }
  return hub;
};

export const fetchPackageHubs = async () => {
  try {
    const response = await customAxios.get("/api/admin/package-hubs");
    const hubs = response?.data?.data;
    if (!Array.isArray(hubs)) throw new Error("The server returned an unexpected response.");
    return hubs;
  } catch (error) {
    throw new Error(getErrorMessage(error, "Could not load the hub locations. Please refresh the page."));
  }
};

export const savePackageHubCoordinates = async ({ code, lat, lon }) => {
  try {
    const response = await customAxios.put(`/api/admin/package-hubs/${encodeURIComponent(code)}`, { lat, lon });
    return readHubFromResponse(response);
  } catch (error) {
    throw new Error(getErrorMessage(error, "Could not save the hub location. Please try again."));
  }
};

export const resetPackageHubCoordinates = async ({ code }) => {
  try {
    const response = await customAxios.delete(`/api/admin/package-hubs/${encodeURIComponent(code)}`);
    return readHubFromResponse(response);
  } catch (error) {
    throw new Error(getErrorMessage(error, "Could not reset the hub location. Please try again."));
  }
};
